/* eslint-disable indent */
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { choose } from 'lit/directives/choose.js';
import { translate } from '../../helpers/translate.js';
import { dialogFooterRenderer, dialogRenderer } from '@vaadin/dialog/lit.js';
import '@vaadin/dialog/theme/material/vaadin-dialog.js';

const dialogTypes = {
    INFO: 'info',
    CONFIRM: 'confirm',
    FORM: 'form',
};

@customElement('sdb-player-dialog')
class SdbPlayerDialog extends LitElement {

    @property({ type: String })
    accessor type = dialogTypes.INFO;

    @property({ type: String })
    accessor heading = '';

    @property({ type: String })
    accessor confirmCaption = translate('btnConfirm');

    @property({ type: String })
    accessor cancelCaption = translate('btnCancel');

    @property({ type: Boolean })
    accessor confirmDisabled = false;

    @property({ type: String })
    accessor body;

    @property({ type: Boolean })
    accessor opened = false;

    @property({ type: Function })
    accessor bodyRenderer;

    @property({ type: String })
    accessor width;

    @property({ type: String })
    accessor height;

    @property({ type: Boolean })
    accessor disableAutoDismiss = false;

    constructor() {
        super();
        this.args = null;
    }

    open(args) {
        this.args = args;
        this.opened = true;
    }

    close() {
        this.opened = false;
    }

    render() {
        return html`
            <vaadin-dialog
                id="tcg_dialog"
                overlay-class="app-theme-container"
                header-title=${this.heading}
                width=${this.width}
                height=${this.height}
                ?opened=${this.opened}
                .noCloseOnEsc=${this.disableAutoDismiss}
                .noCloseOnOutsideClick=${this.disableAutoDismiss}
                @opened-changed=${(e) => { this.opened = e.detail.value; }}
                ${dialogRenderer(this._renderDialog, [this.bodyRenderer])}
                ${dialogFooterRenderer(this._renderFooter, [this.confirmDisabled])}>
            </vaadin-dialog>
        `;
    }

    _renderDialog() {
        return html`
            ${choose(this.type, [
                [dialogTypes.INFO, () => unsafeHTML(`<p>${this.body}</p>`)],
                [dialogTypes.CONFIRM, () => unsafeHTML(`<p ?hidden=${!this.body}>${this.body}</p>`)],
                [dialogTypes.FORM, () => this.bodyRenderer()],
            ], () => html`<p>unknown type</p>`)}
        `;
    }

    _renderFooter() {
        return html`
            <div class="buttons">
                <sdb-content-button
                    label=${this.cancelCaption}
                    outlined
                    ?hidden=${this.type === dialogTypes.INFO}
                    @click=${() => {
                        this._trigger('cancel');
                        this.close();
                     }}>
                </sdb-content-button>
                <sdb-content-button
                    label=${this.confirmCaption}
                    autofocus
                    secondary
                    ?disabled=${this.confirmDisabled}
                    @click=${() => {
                        this._trigger('confirm');
                        this.close();
                    }}>
                </sdb-content-button>
            </div>
        `;
    }

    _trigger(eventName) {
        this.dispatchEvent(
            new CustomEvent(eventName, {
                detail: {
                    args: this.args,
                },
                bubbles: true,
                composed: true,
            }),
        );
    }
}

